export default __webpack_public_path__ + "static/media/06.963f1408.jpg";